import { Component, OnInit, PipeTransform, Pipe, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, RoutesRecognized, NavigationError } from '@angular/router';

import { Platform, MenuController, PopoverController } from '@ionic/angular';
import { Page } from './models/page';
import { UserSession } from './session/user.session';
import { ProfilePopover } from './components/popover/profile-popover';
import { PageService } from './services/page.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {

  public pageType = 2;
  public showLogin = false;
  pagesLoaded = false;

  constructor(
    private menuCtrl: MenuController,
    public userSession: UserSession,
    private popoverController: PopoverController,
    private pageService: PageService
  ) {

    this.userSession.isAuthenticatedOnChange().subscribe(isAuthenticated => {
      this.showLogin = false;
      if(isAuthenticated) {
        this.pageType = 2;
      } else {
        this.userSession.appPages = [];
        this.showLogin = true;

        this.userSession.refreshAuthenticated();
      }
  
      if(this.userSession.appPages.length <= 0) {
          this.pageService.getAll().subscribe((pages : Page[]) => {
            this.userSession.appPages = pages;
          });
      }
    });
  }

  toggleMenu() {
    this.menuCtrl.toggle();
  }

  async presentPopover(ev: any) {
    const popover = await this.popoverController.create({
      component: ProfilePopover,
      event: ev,
      translucent: true,
      mode: "md",
      cssClass: 'test32'
    });

    popover.onDidDismiss().then(data => {
        
    });

    return await popover.present();
}

  public appPages : Page[] = [
    {
      name: 'Users',
      url: '/users',
      icon: 'md-contact',
      roles: [ ],
    },
    {
      name: 'Groups',
      url: '/groups',
      icon: 'md-contact',
      roles: [ ],
    },
    {
      name: 'My money',
      url: '/money',
      icon: 'md-contact',
      roles: [ ],
    },
    {
        name: 'My recipes',
        url: '/recipes',
        icon: 'md-contact',
        roles: [ ],
    },
    {
        name: 'My products',
        url: '/products',
        icon: 'md-contact',
        roles: [ ],
    },
    {
        name: 'My notes',
        url: '/note',
        icon: 'md-clipboard',
        roles: [ ],
    },
    {
        name: 'News',
        url: '/news',
        icon: 'md-clipboard',
        roles: [ ],
    },
    {
        name: 'Gezondheidsmonitor',
        url: '/healthmonitor',
        icon: 'md-clipboard',
        roles: [ ],
    },
    {
        name: 'My Pages',
        url: '/pages',
        icon: 'md-clipboard',
        roles: [ ],
    },
    {
        name: 'Contentmanager',
        url: '/contentmanager',
        icon: 'md-clipboard',
        roles: [ ],
    },
    {
        name: 'Blog',
        url: '/blog',
        icon: 'list',
        roles: [ ],
    },
    {
        name: 'Home',
        url: '/p/home',
        icon: 'list',
        roles: [ ],
    }
  ];

}
